// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608170853/js/" + chunkId + "." + {"44":"8a322f10","225":"723f87ec","481":"a7a88e02","486":"5fb85958","770":"a28091ff"}[chunkId] + ".0.24125598005203186.chunk.js";
};